import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import useIsUserAllowedByPermission from '../hooks/useIsUserAllowedByPermission';

export function RequirePermission({ children, roles = [], permission = [], }) {
  const location = useLocation();
  const isAllowd = useIsUserAllowedByPermission(permission || roles);

  if (!isAllowd) {
    return <Navigate to="/403" state={{ from: location, }} replace />;
  }

  return children;
}

export default RequirePermission;

RequirePermission.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.arrayOf(PropTypes.string),
  roles: PropTypes.arrayOf(PropTypes.string),
};
